import React, { useState, useEffect } from 'react'
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import './index.css'
import Select from 'react-select'
import api from '../../Services/api'
import { AxiosResponse } from "axios";
import { MdOutlineAddCircle } from 'react-icons/md';
import GridSecundario from '../../components/GridSecundario'
import FormTipoAgente from '../../components/FormTipoAgente';
import Loading from '../../components/Loading';
import { useNavigate } from 'react-router';
import secureLocalStorage from "react-secure-storage";
import ModalPrincipal from '../../components/ModalAlert/modal'
import ModalIncluirNovo from '../../components/ModalIncluirNovo/modal'
import DualListBox from "react-dual-listbox";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { useParams } from 'react-router-dom';

function PanelEdit() {
	const navigate = useNavigate();
	let { id } = useParams();

	const [qualTitulo, setQualTitulo] = useState('')
	const [qualGrid, setQualGrid] = useState(<></>)
	const [openModal, setOpenModal] = useState(false)
	const [openModalIncluirNovo, setOpenModalIncluirNovo] = useState(false)
	const [qualAlert, setQualAlert] = useState(<></>)

	const [idCompany, setIdCompany] = useState('')
	const [active, setActive] = useState(true)
	const [description, setDescription] = useState('');
	const [descriptionIni, setDescriptionIni] = useState('');
	const [ambiente, setAmbiente] = useState('');
	const [accesslink, setAccesslink] = useState('');
	const [dateTimeInsert, setDateTimeInsert] = useState('');
	const [dateTimeUpdate, setDateTimeUpdate] = useState('');
	const [id_insert, setId_insert] = useState('');

	const [optionsCompany, setOptionsCompany] = useState([])

	const [optionsPanel, setOptionsPanel] = useState([])

	useEffect(() => {


		setQualAlert(<div className='div-alert'><Loading /></div>)
		setOpenModal(true)

	

		validatToken();



	}, []);


	async function validatToken() {

		let ret: AxiosResponse;
		let valor: any;


		const _user = secureLocalStorage.getItem('t')



		api.defaults.headers.common['Authorization'] = _user as ''

		try {

			ret = await api.get("/status/validar")

			if (ret.data.status === 200) {

				userPainel()
				

			}

		} catch (e: any) {

			if (e.response.data.status === 403) {

				setQualAlert(<div className='div-alert'>
					<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
					<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
					<div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
					<div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
				</div>)

				setOpenModal(true)

			}
		}

	}


	async function userPainel() {
		let ret: AxiosResponse;
		let valor: any;


		if (/^\d+$/.test(id || '') === true) {
			try {
				ret = await api.get("panel/paneleditar", {
					params: {
						id: id
					}
				})
				if (ret.data.status === 200) {

                    await GetCompany()
					await GetPanel()
	
				

					setIdCompany(ret.data.data[0].pnl_id || '')
					setActive(ret.data.data[0].pnl_active != undefined ? Boolean(ret.data.data[0].pnl_active) : true)
					setDescription(ret.data.data[0].pnl_description || '');
					setDescriptionIni(ret.data.data[0].pnl_description || '');
					setAmbiente(String(ret.data.data[0].cpy_id) || '');
					setAccesslink(ret.data.data[0].pnl_accesslink || '')
					setId_insert(ret.data.data[0].pnl_id_insert || '')
					setDateTimeInsert(ret.data.data[0].pnl_datetimeinsert.substring(0, 16) || '')
					setDateTimeUpdate(ret.data.data[0].pnl_datetimeupdate.substring(0, 16) || '');

					setOpenModal(false)
				} else {
					setOpenModal(false)
					navigate('/panel/edit/' + id + '/n');
				}
			} catch (e) {
				setOpenModal(false)
				navigate('/panel/edit/' + id + '/n');
			}

		} else {
			setOpenModal(false)
			navigate('/panel/edit/' + id + '/n');
		}
	}


	async function GetPanel() {
		let ret: AxiosResponse;
		let valor: any;
		try {
			ret = await api.get("panel/listar")
			if (ret.data.status === 200) {
				valor = ret.data.data;

				setOptionsPanel(valor)

			}
		} catch (e) {
			setOptionsPanel([])
		}
	}

	async function GetCompany() {
		let ret: AxiosResponse;
		let valor: any;
		try {
			ret = await api.get("company/listar")
			if (ret.data.status === 200) {

				valor = ret.data.data;
				const arr = [] as any;
				let result = valor;

				result.map((user: any) => {
					return arr.push({ value: String(user.cpy_id), label: user.cpy_description });
				});

				setOptionsCompany(arr)

			}
		} catch (e) {
			setOptionsCompany([])
		}
	}

	function fecharModal() {

		secureLocalStorage.removeItem('t')
		secureLocalStorage.removeItem('acp')
		secureLocalStorage.removeItem('n')
		secureLocalStorage.removeItem('iag')
		navigate('/login');
		setOpenModal(false)

	}



	function ValitarActive() {
		let e = document.getElementById("checkbox-active") as HTMLInputElement;

		if (e.checked) {

			setActive(true)
		} else {

			setActive(false)
		}
	}

	async function confirmarUser() {

		let ret: AxiosResponse;
		let valor: any;

		setQualAlert(<div className='div-alert'><Loading /></div>)
		setOpenModal(true)


		const _user = secureLocalStorage.getItem('t')

		api.defaults.headers.common['Authorization'] = _user as ''

		try {

			ret = await api.get("/status/validar")

			if (ret.data.status === 200) {


				const FiltrarDescription = optionsPanel.filter(
					(e: any) => {
						return e.pnl_description.toLowerCase() === description.toLowerCase()
					}
				);

	

				if (descriptionIni !== description &&  FiltrarDescription.length > 0) {

					setQualAlert(<div className='div-alert'>
						<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
						<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
						<div className='div-info-alert'><span className="info-alert">A descrição já está em uso.</span></div>
						<div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
					</div>)


				} else
						if (description === "") {

							setQualAlert(<div className='div-alert'>
								<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
								<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
								<div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
								<div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
							</div>)


						} else if (ambiente === "") {

							setQualAlert(<div className='div-alert'>
								<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
								<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
								<div className='div-info-alert'><span className="info-alert">Selecione o ambiente.</span></div>
								<div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
							</div>)


						} else if (accesslink === "") {

							setQualAlert(<div className='div-alert'>
								<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
								<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
								<div className='div-info-alert'><span className="info-alert">Digite o link.</span></div>
								<div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
							</div>)

						} else {

							const usuario = secureLocalStorage.getItem('use')

							let ret: AxiosResponse;

							const dados = {
								pnl_id: id,
								pnl_active: active,
								pnl_description: description,
								cpy_id: ambiente,
								pnl_accesslink: accesslink,
								pnl_id_insert: id_insert,
								pnl_id_lastupdate: usuario
							};


							try {
								ret = await api.put("panel/update", {
									data: dados
								});
								if (ret.data.status === 200) {


									setQualAlert(<div className='div-alert'>
										<span className="fa-regular fa-circle-check ControleIconAlert"></span>
										<div className='div-info-alert'><span className="info-alert">Painel alterado com sucesso.</span></div>
										<div className='btn-alert' onClick={finalizarModal1}><span className="btn-alert-lab">OK</span></div>
									</div>)



								}
							} catch (e: any) {

								setQualAlert(<div className='div-alert'>
									<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
									<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
									<div className='div-info-alert'><span className="info-alert">Não foi possivel concluir o cadastramento.</span></div>
									<div className='btn-alert' onClick={finalizarModal2}><span className="btn-alert-lab">OK</span></div>
								</div>)

							}

						}







			}

		} catch (e: any) {

			if (e.response.data.status === 403) {

				setQualAlert(<div className='div-alert'>
					<span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
					<div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
					<div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
					<div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
				</div>)

			}
		}

	}

	function finalizarModal1() {
		navigate('/panel');
	}

	function finalizarModal2() {
		setOpenModal(false)
	}

	function cancelar() {
		navigate('/panel');
	}

	const customStyles = {
		control: (provided: any, state: any) => ({
			...provided,
			background: '#fff',
			minHeight: '30px',
			height: '30px',
			borderColor: state.isFocused ? 'grey' : '#92989e',

		}),


		valueContainer: (provided: any, state: any) => ({
			...provided,
			height: '30px',
			padding: '0 6px'
		}),

		input: (provided: any, state: any) => ({
			...provided,
			margin: '0px',
			fontSize: 14,

		}),
		indicatorsContainer: (provided: any, state: any) => ({
			...provided,
			height: '30px',
		}),
	};


	return (
		<>
			<Nav />
			<div className="main-content">
				<Header />
				<main>
					<div className='containerPrincipal'>
						<div className="title-Page">
							<div className="title-text">
								<div className="size-x circle">1</div>
								<h2>Informações Gerais</h2>
							</div>
							<hr />
						</div>

						<div className="class-checkbox">
							<input type="checkbox" id="checkbox-active" checked={active} onChange={ValitarActive} />
							<h4 className="lab-ativo">Ativo</h4>
						</div>

						<div className="container-cad-prod8 ">
							<div id="content1">
								<div className="input-box-ativos">
									<span className="details">Descrição *</span>
									<input
										type="text"
										onChange={(e) => setDescription(e.target.value)}
										value={description}
									/>

								</div>
							</div>
							
							<div id="content2">
								<div className="select-box-ativos-select">
								
										<span className="details">Ambiente *</span>
										
								
									<Select
										placeholder={'Selecione...'}
										options={optionsCompany}
										styles={customStyles}
										value={optionsCompany.filter(function (option: any) {
											return option.value === ambiente;
										})}
										onChange={(options: any) =>
											!options ? setAmbiente("") : setAmbiente(options.value)
										}
										isClearable
										noOptionsMessage={() => "Não encontrado..."}
										theme={(theme: any) => ({
											...theme,
											borderRadius: 4,
											colors: {
												...theme.colors,
												primary25: '#ebebeb',
												primary: 'black',
											},
										})}

									/>
								</div>
						
							</div>

						</div>

						<div className="container-cad-prod23">
							<div id="content1">
								<div className="input-box-ativos">
									<span className="details">
										Link *</span>
									<input
										type="text"
										onChange={(e) => setAccesslink(e.target.value)}
										value={accesslink}

									/>
								</div>
							</div>

							<div id="content2">

								<div className="input-box-ativos">
									<span className="details">Data da Inclusão</span>
									<input
										type="datetime-local"
										value={dateTimeInsert}
										disabled
									/>
								</div>

							</div>


							<div id="content3">
								<div className="input-box-ativos">
									<span className="details">Data da Última Atualização</span>
									<input
										type="datetime-local"
										value={dateTimeUpdate}
										disabled
									/>
								</div>
							</div>

						</div>


						<div className="Bt-button-cad">
							<button type="submit" onClick={confirmarUser}>
								<i className="fa fa-check-circle icon-ok-btn"></i> Salvar
							</button>
							<button type="submit" onClick={cancelar}>
								<i className="fa fa-times icon-cancelar-btn"></i> Cancelar
							</button>
						</div>

					</div>
				</main>
			</div>


			<ModalPrincipal isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>

				<div className='container-modal-alert'>
					{qualAlert}
				</div>
			</ModalPrincipal>

		</>
	);

}

export default PanelEdit;